var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1258 6.7925L12.8333 5.5L7.33334 11L12.8333 16.5L14.1258 15.2075L9.9275 11L14.1258 6.7925Z",
    fill: "#D4D5D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftDisabled);
export default __webpack_public_path__ + "static/media/ChevronLeftDisabled.c9779abc4bc8765e927c6c5166df5731.svg";
export { ForwardRef as ReactComponent };